import { useRef, useState, useEffect } from "react";
import { useInView } from "framer-motion";

const CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ0123456789/#*<>_%$";

export const ScrambleText = ({ text, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [out, setOut] = useState(text);

  useEffect(() => {
    if (!inView) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setOut(text);
      return;
    }
    let frame = 0;
    let raf;
    const total = text.length;
    const tick = () => {
      const revealed = Math.floor(frame / 0.9);
      let s = "";
      for (let i = 0; i < total; i++) {
        if (i < revealed || text[i] === " ") s += text[i];
        else s += CHARS[Math.floor(Math.random() * CHARS.length)];
      }
      setOut(s);
      frame++;
      if (revealed <= total) raf = requestAnimationFrame(tick);
      else setOut(text);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, text]);

  return <span ref={ref} className={className}>{out}</span>;
};
